import { HelpLink } from 'elements/link/HelpLink'
import { useTranslate } from 'react-admin'

const Subtitle = () => {
  const translate = useTranslate()
  return (
    <span>
      {translate(
        "Create document templates to allow you to quickly generate standard documents for each project, from the Info page in the Projects zone. You can use a customisable template for Owner's Manuals or Installation Instructions, or create your own from scratch."
      )}
      <HelpLink href="https://support.opensolar.com/hc/en-us/articles/12552778816783-How-to-add-or-edit-documents-to-OpenSolar" />
    </span>
  )
}

const DocumentTemplateTitle = ({ record, translate, style }) => {
  return (
    <span style={style}>
      {translate('Document Template')} {record ? `"${record.title}"` : ''}
    </span>
  )
}

export default {
  list: { lazy: () => import('./DocumentTemplates'), component: 'DocumentTemplateList' },
  edit: { lazy: () => import('./DocumentTemplates'), component: 'DocumentTemplateEdit' },
  create: { lazy: () => import('./DocumentTemplates'), component: 'DocumentTemplateCreate' },
  options: {
    create: {
      title: 'Create Template',
      subtitle: null,
      breadCrumb: 'Create Template',
    },
    list: {
      title: 'My Document Templates List',
      subtitle: <Subtitle />,
      breadCrumb: 'Document Templates',
    },
    edit: {
      title: <DocumentTemplateTitle />,
      subtitle: null,
      breadCrumb: 'Edit Template',
    },
  },
}
